import { setupHomepageBrowseByWorkspaceExperimentBucketing } from './homepage_browse_by_workspace_test';
import { setupHomepageRefreshExperimentBucketing } from './homepage_refresh_phase1_test';

export function setupExperimentsBucketing() {
  setupHomepageRefreshExperimentBucketing();
  setupHomepageBrowseByWorkspaceExperimentBucketing();
}
